import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { ElementDetailsLinkService } from 'src/app/Service/element-details-link/element-details-link.service';
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { ElementdetailsService } from 'src/app/Service/elementdetails/elementdetails.service';
import { ElementsService } from 'src/app/Service/elements/elements.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { IElementDetailsSortByInputModel, IElementDetailsViewModel, IProjElementDetail } from 'src/app/ViewModel/ElementDetailsModel';
import { ElementLinkModel } from 'src/app/ViewModel/ElementLinkModel';
import { ElementDetailsLinkSaveModel } from 'src/app/ViewModel/ElementsDetailsLinkSaveModel';
import { IElementsViewModel } from 'src/app/ViewModel/ElementsModel';
import { ModuleModel } from 'src/app/ViewModel/ModuleModel';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { EditElementDetailsComponent } from '../../master/dialogs/elementdetails-dialog/edit-elementdetails-dialog.component';

@Component({
	selector: 'app-element-details-link',
	templateUrl: './element-details-link.component.html',
	styleUrls: ['./element-details-link.component.css']
})
export class ElementDetailsLinkComponent implements OnInit {

	/** Selected business group id */
	businessGroupId!: number;
	/** Selected module id */
	moduleId: number;
	/** Selected element id */
	elementId: number | null = null;
	/** Selected element description */
	elementDesc: string | null = '';
	/** Cart params data */
	cartRequest: any = {}
	/** Cart selected (right side) data */
	cartSelectedList: any[] = [];
	cartSelectedListCopy: [{ value: string; text: string; }] = [{ value: '', text: '' }];
	/** Array of cart's (right side) selected list's ids */
	cartSelectedIds: string[] = [];
	/** Is selected element has dependency */
	elementHasDependency: boolean | null = null;
	/** Selected element id */
	dependentElementId: number | null = null;
	/** Selected element detail id */
	dependentElementDetailId: number | null = null;
	/**Module List */
	moduleList!: ReadonlyArray<ModuleModel>;
	/** Element List */
	elementList!: ReadonlyArray<IElementsViewModel>;
	/** Left side cart data. Filtered with right side data */
	filteredCartList!: IElementDetailsViewModel[];
	/** Dependent Element Details List */
	dependentElementDetailsList!: RoleFeatureModel[];
	/** Business Group List */
	businessGroupList!: ReadonlyArray<BusinessGroupModel>;
	/** Dependent Element List */
	dependentElementList!: ReadonlyArray<ElementLinkModel>;
	/** Element Detail List */
	elementDetailsList!: ReadonlyArray<IElementDetailsViewModel>;
	registerForm!: FormGroup;
	GroupIdString!: string;
	ModuleIdString: string | null = '';
	clearElementDD = 'N';

	constructor(
		public mapRoleFeatureService: MapRoleFeatureService,
		public commonService: CommonService,
		public notificationService: NotificationService,
		public elementLinkService: ElementLinkService,
		public elementDetailLinkService: ElementDetailsLinkService,
		public elementDetailsService: ElementdetailsService,
		public elementService: ElementsService,
		private dialog: MatDialog,
		private formBuilder: FormBuilder
	) { }

	ngOnInit() {
		this.createForm();
		this.commonService.selectedProjectId.subscribe((data: any) => {
			if (data != null || data != undefined) {
				this.getBusinessGroups(data);
			}
		});
		this.getModuleList(0);
	}

	createForm() {
		this.registerForm = this.formBuilder.group({
			orderBy: ['', Validators.required],
		});

	}
	/**
	 * Get Business Group list
	 * @param projectId 
	 */
	async getBusinessGroups(projectId: number) {
		let response: any = await this.mapRoleFeatureService.getBusinessGroups(projectId).toPromise();
		this.businessGroupList = response.filter((each: {
			is_Active: any;
		}) => each.is_Active);
	}

	/**
	 * Get module List
	 * @param businessGroupId 
	 */
	async getModuleList(businessGroupId: number) {
		let x = await this.elementLinkService.getModuleList(businessGroupId).toPromise();
		this.moduleList = await this.elementLinkService.getModuleList(businessGroupId).toPromise();
	}

	/**
	 * Get element list
	 */
	async getElementList() {
		let response: any = await this.elementService.GetElementsList().toPromise();
		this.elementList = response.filter((each: {
			is_Active: any;
		}) => each.is_Active);
	}

	/**
	 * Get dependent element list
	 */
	getDependentElements() {
		this.elementDetailLinkService.getDependentElements(this.commonService.getProjectId(), this.GroupIdString, this.ModuleIdString, this.elementId).subscribe((data: any) => {
			this.dependentElementList = [data];
		});
	}

	/**
	 * Get left and right side cart values
	 * @param hasDependency 
	 */
	async callApis(hasDependency?: boolean) {
		this.elementDetailsList = await this.elementDetailsService.GetElementDetailsList(this.elementId).toPromise();

		let selectedArr: any = await this.mapRoleFeatureService.getDedAgainstDe(this.elementDesc, this.GroupIdString, this.ModuleIdString, this.dependentElementId, this.dependentElementDetailId ? this.dependentElementDetailId : 0).toPromise();
		this.cartSelectedList = [];
		this.cartSelectedListCopy = [{
			value: '',
			text: ''
		}];
		selectedArr.forEach((eachData: {
			dedId: string | number; dedShortDescription: string; dedDescription: string; sortBy: any;
		}) => {
			if (!this.cartSelectedList || !this.cartSelectedList.some(x => x.value == eachData.dedId && x.text ==
				(eachData.dedShortDescription ? eachData.dedShortDescription + ' - ' : '') + eachData.dedDescription)) {
				this.cartSelectedList.push({
					value: eachData.dedId,
					text: (eachData.dedShortDescription ? eachData.dedShortDescription + ' - ' : '') + eachData.dedDescription,
					orderBy: (!!eachData.sortBy && eachData.sortBy != 0) ? eachData.sortBy : this.cartSelectedList.length + 1
				});
			}
			this.cartSelectedListCopy.push(this.getAsCartValue(eachData.dedId, eachData.dedDescription, (!!eachData.sortBy && eachData.sortBy != 0) ? eachData.sortBy : this.cartSelectedListCopy.length + 1));
			this.cartSelectedIds.push(eachData.dedId.toString());
		});

		this.filteredCartList = [];
		this.filteredCartList = this.elementDetailsList.filter(x => x.is_Active && !selectedArr.find((y: {
			dedId: number | undefined;
		}) => y.dedId == x.deD_Id))
		this.filteredCartList.forEach(x => x.deD_Description = (x.deD_Short_Description ? x.deD_Short_Description + ' - ' : '') + x.deD_Description);
		this.setCartParams();

		if (this.elementHasDependency) {
			this.getDependentElements();
		} else { }
	}

	changeBusinessGroup(event: EIPAutoCompleteEventModel<BusinessGroupModel>) {
		if (event.value != '-2') {
			this.businessGroupId = Number(event.value);
			this.getModuleList(Number(event.value));
		}
		this.elementList = this.dependentElementList = this.dependentElementDetailsList = [];
		this.ModuleIdString = this.elementDesc = this.elementId = this.dependentElementId = this.dependentElementDetailId = null;
	}

	changeModule(event: any) {
		let selectedMemberIds: number[] = event.emittingList.map((x: {
			value: any;
		}) => x.value);
		this.clearElementDD = "Y";
		this.elementList = [];
		if (selectedMemberIds && selectedMemberIds.length > 0) {
			this.ModuleIdString = selectedMemberIds.toString();
			this.getElementList();
		} else {
			this.clearCart();
		}
		this.elementDetailsList = [];
		this.dependentElementDetailsList = this.dependentElementList = [];
		this.elementId = this.dependentElementDetailId = this.dependentElementId = null;
	}

	async changeElement(event: EIPAutoCompleteEventModel<ElementLinkModel>) {
		this.clearElementDD = 'N';
		this.dependentElementList = [];
		if (event.value != '-2') {
			this.elementId = Number(event.value);
			this.elementDesc = event.text;
			let flagResponse = await this.elementLinkService.getDependentFlag(this.GroupIdString, this.ModuleIdString, this.elementId).toPromise();
			this.elementHasDependency = flagResponse['hasDependency'];

			this.callApis(this.elementHasDependency);
		} else {
			this.elementId = this.elementDesc = this.elementHasDependency = null;
			this.clearCart();
		}
		this.dependentElementDetailsList = [];
		this.dependentElementId = null;
	}

	changeDependentElement(event: EIPAutoCompleteEventModel<ElementLinkModel>) {
		if (event['value'] != '-2') {
			this.dependentElementId = Number(event['value']);
			this.clearCart();
			this.mapRoleFeatureService.getDedAgainstDe(event['desc'], this.GroupIdString, this.ModuleIdString, null).subscribe((data: any) => {
				this.dependentElementDetailsList = data;
				if (this.dependentElementDetailsList && this.dependentElementDetailsList.length > 0) {
					this.dependentElementDetailsList.forEach(obj => {
						obj.dedDescription = obj.dedShortDescription + ' - ' + obj.dedDescription
					});
				}
			});
		} else {

			this.callApis(this.elementHasDependency);
			this.dependentElementId = this.dependentElementDetailId = null;
			this.dependentElementDetailsList = [];
		}
	}

	changeDependentElementDetail(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.dependentElementDetailId = Number(event['value']);
			this.elementHasDependency = false;
			this.callApis(this.elementHasDependency);
		} else {
			this.dependentElementDetailId = null;
		}
	}

	/**
	 * Event handling when click 'Post' in cart
	 * @param event 
	 */
	getSelectedCartItems(event: any) {
		this.saveElementDetailLink(event);
	}

	/**
	 * Save Element Detail Link
	 * @param event 
	 */
	public gridView!: any[];
	openGridView(data?: any) { }

	saveElementDetailLink(event: any) {
		if (this.dependentElementId && !this.dependentElementDetailId) {
			this.notificationService.showToast("Select Dependent Element Detail", 'Warning');
			return;
		}

		let newActiveIds = this.getIdAsArray(event),
			newInActiveIds = this.getInActiveIds(newActiveIds),
			reqData: ElementDetailsLinkSaveModel = {
				ProjectId: this.commonService.getProjectId(),
				GroupId: this.GroupIdString,
				ModuleId: this.ModuleIdString,
				ElementId: this.elementId,
				DependentElementId: this.dependentElementId,
				DependentElementDetailedId: this.dependentElementDetailId ? this.dependentElementDetailId : 0,
				ActiveElementDetailedIds: newActiveIds.length ? newActiveIds.toString() : null,
				InactiveElementDetailedIds: newInActiveIds.length ? newInActiveIds.toString() : null,
				CreatedBy: this.commonService.getLoggedInUserId(),
			};
		this.elementDetailLinkService.saveElementsDetailsLink(reqData).subscribe((data: any) => {
			this.notificationService.handleResponse(data);
			this.callApis();
		});
	}

	getInActiveIds(currentSelectedIds: number[]): number[] {
		let inActiveIds: number[] = [];
		this.cartSelectedListCopy.forEach(eachSelected => {
			if (!currentSelectedIds.includes(Number(eachSelected['value']))) {
				inActiveIds.push(Number(eachSelected['value']));
			}
		});
		return inActiveIds;
	}

	/**
	 * Return selected value as array of ids
	 * Ex: [2,5,4,6,1]
	 * @param eventArr 
	 */
	getIdAsArray(eventArr: []): number[] {
		let valueArr: number[] = [];
		eventArr.forEach(eachEvent => {
			valueArr.push(eachEvent['value'])
		});
		return valueArr
	}

	/**
	 * Setting cart data
	 */
	setCartParams() {
		this.cartRequest = {
			'params': {
				'intCompanyCode': '1', 'intRegionCode': '376', 'DOPTCode': 'C', 'DTCode': '30016', 'UserID': '3095',
				'dtValuationPeriod': '31-05-2019',
				'LockingType': 'P',
				'selectedCartItems': this.cartSelectedList
			},
			'settings': {
				'mode': 'popup',
				'textField': 'deD_Description',
				'valueField': 'deD_Id',
				'cartLabel': 'Element Detail',
				'minimumSelectedItemCount': 0
			},
			'dataSource': this.filteredCartList,
		}
	}

	/**
	 * Clear cart left, right values
	 */
	clearCart() {
		this.cartSelectedList = [];
		this.filteredCartList = [];
		this.setCartParams();
	}

	/**
	 * Get as cart's selected data format
	 * @param value 
	 * @param text 
	 */
	getAsCartValue(value: string | number, text: string, sortBy: number) {
		value = value.toString().trim();
		text = text.trim();

		return {
			value: value,
			text: value + ' - ' + text,
			orderBy: sortBy
		};
	}

	openElementDetailDialog() {
		if (!this.GroupIdString) {
			this.notificationService.showToast('Select Business Group', 'Warning');
			return;
		}
		if (!this.ModuleIdString) {
			this.notificationService.showToast('Select Module', 'Warning');
			return;
		}
		if (!this.elementId) {
			this.notificationService.showToast('Select Element', 'Warning');
			return;
		}
		const dialogRef = this.dialog.open(EditElementDetailsComponent, {
			panelClass: 'mat-dialog-secondary',
			width: '95%',
			minWidth: '95vw',
			data: {
				elementdetails: null,
				elementId: this.elementId,
				elementList: this.elementList
			}
		});

		dialogRef.afterClosed().subscribe((data: any) => {
			this.callApis();
		});
	}

	onChange_Member(event: any, num: any) {
		if (!!event) {
			let selectedMemberIds: number[] = event.emittingList.map((x: {
				value: any;
			}) => x.value);
			this.GroupIdString = selectedMemberIds.toString();
			this.elementList = this.dependentElementList = this.dependentElementDetailsList = [];
			this.elementDesc = this.elementId = this.dependentElementId = this.dependentElementDetailId = null;
		}
	}

	updateElementDetailsSortOrder() {
		let elementDetailsSortBy: IProjElementDetail[] = this.cartSelectedList.map((x, index) => {
			let elementDetails: IProjElementDetail = {
				deD_Id: x.value,
				sort_By: (!!x.orderBy && Number.isInteger(x.orderBy) && x.orderBy != 0) ? x.orderBy : index + 1
			};
			return elementDetails;
		})
		let elementDetailsOrderBy: IElementDetailsSortByInputModel = {
			projectId: this.commonService.getProjectId(),
			groupId: this.GroupIdString,
			moduleId: this.ModuleIdString,
			deId: this.elementId,
			userId: this.commonService.getLoggedInUserId(),
			projElementDetails: elementDetailsSortBy
		}
		this.elementDetailLinkService.updateElementDetailsSortby(elementDetailsOrderBy).subscribe((res: StandardOutputModel) => {
			if (res.successCode == 200 && res.successMessage) {
				this.notificationService.showToast(res.successMessage, "Success");
			}
		})
	}
}

